import React, { useState } from 'react';
import config from '../../../../config';
import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter';
import * as Yup from 'yup';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import Header from '../../../components/Header/Header';
import Toolbar from '../../../components/Toolbar/Toolbar';
import Table from '../../../components/Table/Table';
import NavBar from '../../../components/NavBar/NavBar';
import OneToManyDialog from '../../../components/OneToManyDialog';
import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter';
import { Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Package = () => {
  const urls = {
    list: config.PACKAGE,
    create: config.PACKAGE,
    update: config.PACKAGE_WITH_ID,
    delete: config.PACKAGE_WITH_ID
  };
  const [products, setProducts] = useState([]);
  const resource = 'PRODUCT';
  const { t } = useTranslation();

  const columns = [
    {
      header: t('id'),
      name: 'packageId',
      type: 'number',
      filterEditor: NumberFilter
    },
    {
      header: t('name'),
      name: 'name',
      type: 'string',
      validationSchema: Yup.string().max(255).required('Name is required'),
      required: true,
      isEditable: true,
      defaultFlex: 1
    },
    {
      header: t('description'),
      type: 'string',
      isEditable: true,
      name: 'description'
    },
    {
      header: t('type'),
      name: 'productType',
      type: 'select',
      render: ({ value }) => value && value.productTypeName,
      isEditable: false
    },
    {
      header: t('product.id'),
      name: 'productId',
      id: 'productId',
      type: 'number',
      render: ({ data }) => data && data.productId,
      filterEditor: NumberFilter
    },
    {
      header: t('is.active'),
      name: 'isActive',
      type: 'boolean',
      isEditable: true,
      filterEditor: BoolFilter,
      render: ({ value }) => <Switch disabled checked={value} />
    },
    {
      header: t('date.added'),
      name: 'dateAdded',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    },
    {
      header: t('date.modified'),
      name: 'dateModified',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    }
  ];

  return (
    <>
      <Header title={t('tv.packages')} />
      <Toolbar iamResource={resource} />
      <Table
        iamResource={resource}
        uniqueId={'packageId'}
        tableId={'package'}
        columns={columns}
        urls={urls}
      />
      <NavBar />
      <OneToManyDialog
        columns={[
          {
            header: t('id'),
            name: 'productId',
            defaultFlex: 1
          },
          {
            header: t('name'),
            name: 'name',
            defaultFlex: 1
          },
          {
            header: t('description'),
            name: 'description',
            defaultFlex: 1
          },
          {
            header: t('type'),
            name: 'productType',
            render: ({ value }) => value.productTypeName,
            defaultFlex: 1
          },
          {
            header: t('date.added'),
            name: 'dateAdded',
            defaultFlex: 1
          },
          {
            header: t('date.modified'),
            name: 'dateModified',
            defaultFlex: 1
          }
        ]}
        data={products}
        open={products.length > 0}
        handleClose={() => {
          setProducts([]);
        }}
      />
    </>
  );
};

export default Package;
